import deepMapKeys from 'deep-map-keys'
import { getDevAccessHeaders } from '@educator/lib/utils/devStagingAccessHeaders'
import { getHeaders } from '@educator/pages/api/getHeaders'
import { reportError } from '@mc/next-newrelic'
import { snakeToCamelCase } from '../libs/utils/string'

export interface EducatorUser {
  sub: string
  name?: string
  email?: string
  picture?: string
  nickname?: string
  updatedAt?: string
  shouldShowRoleplayOnboarding?: boolean
}

export const getUser = async (accessToken: string) => {
  try {
    const response = await fetch(
      `${process.env.EDUCATOR_SERVER_URL}/jsonapi/v1/users/current`,
      {
        method: 'GET',
        headers: {
          authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          ...getHeaders(),
          ...(getDevAccessHeaders() || {}),
        },
      },
    )

    if (!response.ok) {
      return null
    }

    const body = await response.json()
    const mapped = deepMapKeys(body, snakeToCamelCase)
    return mapped as EducatorUser
  } catch (err) {
    reportError(err, {
      location: 'getUser',
      message: 'Failed to fetch user info from OAuth',
    })
    return null
  }
}
